import React from 'react';

/**
 * Context properties keys must match clientsURI context properties
 * */
export default React.createContext({
  unitsClient: {},
  reportsClient: {},
  wizardClient: {},
});
